import { IInformation } from '../../../interfaces/Information.interfaces';
import { customAxios } from '../../common/customAxios';

interface IGetInformationNeighborsByIdParams {
  informationId: string;
}

export const getInformationNeighborsById = ({
  informationId,
}: IGetInformationNeighborsByIdParams): Promise<IInformation[]> => {
  return customAxios.get(`/informations/${informationId}/neighbors`);
};
